import usePagination from "@mui/material/usePagination";
import { styled } from "@mui/material/styles";

const List = styled("ul")({
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
});

export default function CustomPagination({
  totalPages = 1,
  page = 0,
  onPageChange = () => {},
}) {
  const { items } = usePagination({
    count: totalPages,
    page,
    onChange: (_, value) => onPageChange(value),
  });

  console.log(items, "--items");
  if (totalPages === 0) {
    return <></>;
  }
  return (
    <nav aria-label="Pagination Navigation">
      <List className="custom-pagination">
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;

          if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = <span className="ellipsis">…</span>;
          } else if (type === "page") {
            children = (
              <button
                type="button"
                className="page-btn"
                aria-current={selected ? "true" : undefined}
                {...item}
              >
                {page}
              </button>
            );
          } else {
            children = (
              <button
                type="button"
                className={`navigation-btn btn-${type}`}
                {...item}
              >
                {type}
              </button>
            );
          }

          return <li key={`${type}-${page ?? index}`}>{children}</li>;
        })}
      </List>
    </nav>
  );
}
